/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      19 February 2024
 */

import VideoContainer from '../../Components/VideoContainer';

const Dome = () => {
  return (
    <div className='container max-w-[1920px] pt-8 sm:px-6 xl:px-10 mx-auto'>
      <VideoContainer video='https://www.youtube.com/embed/kc90BHMNfDY' />
    </div>
  );
};
export default Dome;
